// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import Ajax from '@/js/ajax.js';
import './css/element/theme/index.css';
// 引入接口
import serverUrl from './js/server-config.js';
// 引入echarts
import * as echarts from 'echarts';
import i18n from './js/lang/index';
import { setLang } from '@/js/common.js';
import './components/iconfont/iconfont.js'

Vue.config.productionTip = false
Vue.prototype.Ajax = Ajax;
Vue.prototype.setLang = setLang;
Vue.use(ElementUI);

Vue.prototype.$echarts = echarts;
// 全局api
window.API = serverUrl;
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js